<div class=" container-fluid" class="rmg"><router-outlet ></router-outlet></div>